// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"NonstopPower_TheComp__LuLkz"};